import {createSlice} from "@reduxjs/toolkit"
import drugstate_international from "ressources/data/drugs_international.json"
import drugstate_default from "ressources/data/drugs.json"
import initialEffectState from "ressources/data/effects.json"
import {dataService} from "services/data.service"

let initialDrugState

if (process.env.REACT_APP_MODE === "STANDALONE") {
	initialDrugState = drugstate_international
} else {
	initialDrugState = drugstate_default
}

function getIndex(list, drugToFind) {
	return list.findIndex(drug => drug === drugToFind)
}

function moveElement(source, target, drug) {
	const index = getIndex(source, drug)
	if (index >= 0) {
		const drug = source.splice(index, 1)[0]
		target.push(drug)
	} else {
		console.log("not found in list")
	}
}

const initialState = {
	drugs: initialDrugState,
	effects: initialEffectState
}

export const graphSlice = createSlice({
	name: "graph",
	initialState: initialState,
	reducers: {
		includeDrug(state, action) {
			moveElement(state.drugs.excluded, state.drugs.included, action.payload)
		},
		excludeDrug(state, action) {
			moveElement(state.drugs.included, state.drugs.excluded, action.payload)
		},
		includeEffect(state, action) {
			moveElement(state.effects.excluded, state.effects.included, action.payload)
		},
		excludeEffect(state, action) {
			moveElement(state.effects.included, state.effects.excluded, action.payload)
		},
		drugUp(state, action) {
			const drugs = state.drugs.included
			const index = getIndex(drugs, action.payload)
			if (index > 0) {
				[drugs[index - 1], drugs[index]] = [drugs[index], drugs[index - 1]]
			}
		},
		drugDown(state, action) {
			const drugs = state.drugs.included
			const index = getIndex(drugs, action.payload)
			if (0 <= index && index < drugs.length - 1) {
				[drugs[index], drugs[index + 1]] = [drugs[index + 1], drugs[index]]
			}
		},
		sort(state, action) {
			const getRank = drug => parseInt(dataService.getDatapoint(drug, action.payload)["rank"])
			state.drugs.included.sort((d1, d2) => getRank(d1) - getRank(d2))
			state.drugs.sort = action.payload
		},
		reset(state) {
			state = initialState
		},
		sortDrugsAlphabetically(state) {
			state.drugs.included.sort((a, b) => a.localeCompare(b));
		}
	}
})

export const {includeDrug, excludeDrug, includeEffect, excludeEffect, drugUp, drugDown, sort, reset, sortDrugsAlphabetically} = graphSlice.actions
export default graphSlice.reducer

export const includedSelector = (state) => {
	return {
		drugs: state.graph.drugs.included,
		effects: state.graph.effects.included
	}
}

export const includedEffects = state => state.graph.effects.included
export const excludedEffects = state => state.graph.effects.excluded
export const includedDrugs = state => state.graph.drugs.included
export const excludedDrugs = state => state.graph.drugs.excluded
